import React, {useState, useEffect} from 'react'
import CatalogueFilterSliderInput from './catalogue-filter-slider-input'
import CatalogueFilterSliderCircle from './catalogue-filter-slider-circle'
import withApiService from "../../hoc/with-api-service";
import withData from "../../hoc/with-data";

const CatalogueFilterSlider = ({response, minPriceFilter, setMinPriceFilter, maxPriceFilter, setMaxPriceFilter}) => {
  const minPrice = 0;
  const lineWhiteWidth = 224;

  const [maxPrice, setMaxPrice] = useState(0);
  const [userMinPrice, setUserMinPrice] = useState(minPriceFilter);
  const [userMaxPrice, setUserMaxPrice] = useState(maxPriceFilter);
  const [coloredLineLeft, setColoredLineLeft] = useState(minPrice);
  const [coloredLineWidth, setColoredLineWidth] = useState(lineWhiteWidth);

  const sliderStep = maxPrice / lineWhiteWidth;

  const {data} = response;

  const coloredLineStyle = {
    left: `${coloredLineLeft}px`,
    width: `${coloredLineWidth - coloredLineLeft}px`
  };

  useEffect(() => {
    if (data) {
      const newMaxPrice = data.length && data[0].price;
      setMaxPrice(newMaxPrice)
    }
  }, [data]);

  useEffect(() => {
    setUserMinPrice(minPrice);
    setUserMaxPrice(maxPrice)
  }, [maxPrice]);

  useEffect(() => {
    setMinPriceFilter(userMinPrice);
    setMaxPriceFilter(userMaxPrice);
    setColoredLineLeft((userMinPrice / sliderStep).toFixed());
    setColoredLineWidth((userMaxPrice / sliderStep).toFixed());
  }, [userMinPrice, userMaxPrice]);

  useEffect(() => {
    if (!maxPriceFilter) {
      setUserMinPrice(0);
      setUserMaxPrice(maxPrice)
    }
  }, [maxPriceFilter]);

  return (
    <div className="price-slider">
      <div className="circle-container">
        <CatalogueFilterSliderCircle className="circle-1"
                                     sliderStep={sliderStep}
                                     minValue={minPrice}
                                     maxValue={userMaxPrice}
                                     position={userMinPrice}
                                     setPosition={setUserMinPrice}
                                     setColoredLinePos={setColoredLineLeft}/>
        <div className="line-white"/>
        <div className="line-colored"
             style={coloredLineStyle}/>
        <CatalogueFilterSliderCircle className="circle-2"
                                     sliderStep={sliderStep}
                                     minValue={userMinPrice}
                                     maxValue={maxPrice}
                                     position={userMaxPrice}
                                     setPosition={setUserMaxPrice}
                                     setColoredLinePos={setColoredLineWidth}/>
      </div>
      <div className="counter">
        <CatalogueFilterSliderInput className="input-1"
                                    minValue={minPrice}
                                    maxValue={userMaxPrice}
                                    value={userMinPrice}
                                    setPrice={setUserMinPrice}/>
        <div className="input-separator"/>
        <CatalogueFilterSliderInput className="input-2"
                                    minValue={userMinPrice}
                                    maxValue={maxPrice}
                                    value={userMaxPrice}
                                    setPrice={setUserMaxPrice}/>
      </div>
    </div>
  )
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getProducts
  };
};

export default withApiService(mapMethodsToProps)(withData(CatalogueFilterSlider))
